module.exports = __webpack_public_path__ + "img/cns_libertas-logo.48bd56a0.jpg";